import React, { useState } from 'react'
import { Loader } from "react-overlay-loader"
import { Link } from 'react-router-dom'
import { toast } from "react-toastify"
import Logo from "../assets/images/Logo.png"
import { axiosInstance } from '../config/https'
import "./login.css"
import { GoogleLogin } from '@react-oauth/google'
import ReactFacebookLogin from 'react-facebook-login'

export default function Login() {

  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const Login = () => {
    if (email === '' && password === '') {
      toast.warning('email, password is required');
    } else if (email === '') {
      toast.warning('email is required');
    } else if (password === '') {
      toast.warning('password is required');
    } else {
      setLoader(true)
      const formData = {
        email: email,
        password: password
      };
      axiosInstance.post("user/userlogin", formData)
        .then((response) => {
          setLoader(false)
          if (response?.data?.status) {
            console.log("login", response)
            toast.success(response.data.message)
            localStorage.setItem('Token', response.data.token);
            setTimeout(() => {
              window.location.assign("/");
            }, 1000);
            // navigate("/Dashboard")

          }else {
            toast.warn(response?.data?.message)


          }
        }).catch(() => {
          setLoader(false)


        
        })
    }
  }

  const googleLogin = (e) => {
    setLoader(true);
    const rowData = {
      access_token: e,
    };
    axiosInstance.post("user/signupwithgoogle", rowData)
      .then((response) => {
        setLoader(false);
        if (response?.data?.status) {
          localStorage.setItem('Token', response.data.token);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.assign("/");
          }, 1000);
          // navigate("/Dashboard")
        }
      })
  }

  const facebookLogin = (e) => {
    console.log('facebook', e);
    setLoader(true);
    const rowData = {
      access_token: e.accessToken,
    };
    axiosInstance.post("user/signupwithfacebook", rowData)
      .then((response) => {
        setLoader(false);
        if (response?.data?.status) {
          localStorage.setItem('Token', response.data.token);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.assign("/");
          }, 1000);
          // navigate("/Dashboard")
        }
      })
  }

  return (

    <>
      {loader === true ? <Loader fullPage loading /> : null}
      <section className=' d-flex align-items-center' style={{ height: "100vh" }}>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-6'>
              <div className='login'>
                <div className="head">
                  <img src={Logo} alt='' />
                </div>
                <p className="msg mt-4 para">Login Your Account</p>
                <div className="form">
                  <form>
                    <input
                      placeholder="Enter Your Email"
                      className="text"
                      type="email"
                      id="username"
                      required=""
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <br />
                    <input
                      type="password"
                      placeholder="Enter Your Password"
                      className="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <br />
                    <div className='row'>
                      <div className='col-md-12 mt-2 d-flex align-items-center justify-content-between'>
                        <button
                          className="btn-login rounded-pill" type='button' onClick={() => Login()} >
                          Login
                        </button>
                        <Link to="/Forgetpassword" className="forgot">
                          Forget Password?
                        </Link>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 mt-2 d-flex justify-content-center'>
                        <GoogleLogin
                          onSuccess={credentialResponse => {
                            googleLogin(credentialResponse.credential);
                          }}
                          onError={() => {
                            console.log('Login Failed');
                          }}
                        />
                      </div>
                      <div className='col-md-12 mt-2 d-flex justify-content-center'>
                        <ReactFacebookLogin
                          appId="1474520929751225"
                          // autoLoad={true}
                          fields="name,email,picture"
                          // onClick={componentClicked}
                          callback={facebookLogin}
                        />
                      </div>
                    </div>
                  </form>
                  <div className='row'>
                    <div className='col-md-12 text-center mt-4'>
                      <h6>Don't have an account?<Link to="/Signup"> Signup</Link></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

    </>


  )
}
